import type { ApiClient } from '../../core/api-client.js';
import { ApiError } from '../../core/api-client.js';
import type { Resultado } from '../../core/resultado.js';
import type { RegistroPermissao } from '@pgcustom/shared-types';

/** Adapter do módulo Papéis e Permissões no frontend — `GET /api/v1/auth/permissoes` (recurso `auth`, só `admin`). Só leitura — RBAC continua definido por seed/migration, nenhuma rota de escrita existe. */
export class PapeisPermissoesApi {
  constructor(private readonly api: ApiClient) {}

  async listar(): Promise<Resultado<RegistroPermissao[]>> {
    try {
      const resposta = await this.api.get<{ permissoes: RegistroPermissao[] }>('/auth/permissoes');
      if (resposta.permissoes.length === 0) return { status: 'vazio' };
      return { status: 'ok', dado: resposta.permissoes };
    } catch (erro) {
      if (erro instanceof ApiError && erro.status === 403) return { status: 'sem-permissao' };
      return { status: 'erro', mensagem: erro instanceof ApiError ? erro.message : 'falha ao carregar permissões' };
    }
  }
}
